import React, { useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { AnimatePresence, motion } from "framer-motion";

const variants = {
  enter: (direction) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
};

const swipeConfidenceThreshold = 10000;

const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

export function Hero({
  gradient = "",
  children = null,
  color = "",
  type = "",
}) {
  const images = {
    home: <HeroHome />,
    home2: <HeroHome2 />,
    home3: <HeroHome3 />,
    about: <HeroAbout />,
    giag: <HeroGIAG />,
  };
  const rawImages = {
    home: "/home-01.jpg",
    home2: "/home-02.jpg",
    home3: "/home-03.jpg",
    about: "/heroAbout.jpg",
    giag: "/heroGIAG.jpg",
  };

  const [imageKey, setImageKey] = useState(() => {
    let key = null;

    if (type === "home" || type === "music") {
      key = "home";
    } else if (type === "about") {
      key = "about";
    } else if (type === "GIAG") {
      key = "giag";
    }

    return key;
  });

  const [direction, setDirection] = useState(1);

  const img = images[imageKey];
  const rawImg = rawImages[imageKey];

  useEffect(() => {
    if (type === "home") {
      const timeout = setTimeout(() => {
        handleNextPage(1);
      }, 5000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [type, direction, imageKey]);

  function handleNextPage(direction) {
    setImageKey((currentKey) => {
      const keys = Object.keys(images);
      const index = keys.indexOf(currentKey);

      if (direction > 0) {
        let nextIndex = index + 1;

        if (nextIndex > keys.length - 3) {
          nextIndex = 0;
        }
        return keys[nextIndex];
      } else {
        let nextIndex = index - 1;

        if (0 > nextIndex) {
          nextIndex = keys.length - 3;
        }
        return keys[nextIndex];
      }
    });
    setDirection(direction);
  }

  return (
    <div className={`hero hero--${color} hero--${type}`}>
      {type === "home" ? (
        <React.Fragment>
          <AnimatePresence initial={false} custom={direction}>
            <motion.img
              key={imageKey}
              className="hero__img hero__img--animated"
              src={rawImg}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{
                x: { type: "spring", stiffness: 300, damping: 30 },
                opacity: { duration: 0.2 },
              }}
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              dragElastic={1}
              onDragEnd={(e, { offset, velocity }) => {
                const swipe = swipePower(offset.x, velocity.x);

                if (swipe < -swipeConfidenceThreshold) {
                  handleNextPage(1);
                } else if (swipe > swipeConfidenceThreshold) {
                  handleNextPage(-1);
                }
              }}
            ></motion.img>
          </AnimatePresence>
          <button
            className="hero__control hero__control--prev"
            onClick={() => handleNextPage(-1)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
              <path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z" />
            </svg>
          </button>
          <button
            className="hero__control hero__control--next"
            onClick={() => handleNextPage(1)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
              <path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z" />
            </svg>
          </button>
        </React.Fragment>
      ) : (
        <React.Fragment>{img}</React.Fragment>
      )}
      <div
        style={{
          background: gradient,
        }}
        className="hero__gradient"
      ></div>
      <div className="hero__content">{children}</div>
    </div>
  );
}

function HeroHome() {
  return (
    <StaticImage
      src="../images/home-01.jpg"
      alt=""
      layout="fullWidth"
      objectFit="cover"
      objectPosition="center"
      // height={783}
    />
  );
}
function HeroHome2() {
  return (
    <StaticImage
      src="../images/home-02.jpg"
      alt=""
      layout="fullWidth"
      objectFit="cover"
      objectPosition="center"
      // height={783}
    />
  );
}
function HeroHome3() {
  return (
    <StaticImage
      src="../images/home-03.jpg"
      alt=""
      layout="fullWidth"
      objectFit="cover"
      objectPosition="center"
      // height={783}
    />
  );
}
function HeroAbout() {
  return (
    <StaticImage
      src="../images/heroAbout.png"
      alt=""
      layout="fullWidth"
      objectFit="cover"
      objectPosition="center"
      // height={565}
    />
  );
}

function HeroGIAG() {
  return (
    <StaticImage
      src="../images/heroGIAG.png"
      alt=""
      layout="fullWidth"
      objectFit="cover"
      objectPosition="center"
      // height={565}
    />
  );
}
